// ─────────────────────────────────────────────────────────────────────────────
// tokens/typography.ts
// ─────────────────────────────────────────────────────────────────────────────

export const fontFamily = `-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`;
export const fontMono   = `'SFMono-Regular', Consolas, 'Liberation Mono', monospace`;

export const fontWeightRegular = 400;
export const fontWeightBold    = 600;

// Tamanhos com papéis semânticos
export const fontSizeTitle      = '22px';
export const fontSizeHeading    = '18px';
export const fontSizeSubheading = '15px';
export const fontSizeBody       = '13px';
export const fontSizeLabel      = '11px';
export const fontSizeCaption    = '11px';

// Alias numérico (para uso em styled-components)
export const fontSize = {
  title:      22,
  heading:    18,
  subheading: 15,
  body:       13,
  label:      11,
  caption:    11,
} as const;

export const typography = {
  fontFamily,
  fontMono,
  weight: {
    regular: fontWeightRegular,
    bold:    fontWeightBold,
  },
  size: fontSize,
} as const;
